import auth0 from "auth0-js";
import jwtDecode from "jwt-decode";

export default class Auth {
  constructor(token) {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);

    this.auth0 = new auth0.WebAuth({
      domain: process.env.REACT_APP_AUTH0_DOMAIN,
      clientID: process.env.REACT_APP_AUTH0_CLIENTID,
      redirectUri: process.env.REACT_APP_AUTH0_REDIRECTURI,
      responseType: "token id_token",
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: "openid user_metadata read:current_user update:current_user_metadata"
    });

    if (token) {
      this.auth0Manage = new auth0.Management({ domain: process.env.REACT_APP_AUTH0_DOMAIN, token });
    }
  }

  login() {
    this.auth0.authorize();
  }

  handleAuthentication(sucessCallback, errorCallback) {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        Auth.setSession(authResult);
        sucessCallback(authResult);
      } else if (err) {
        errorCallback(err);
      }
    });
  }

  logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    this.auth0.logout({
      clientID: process.env.REACT_APP_AUTH0_CLIENTID,
      returnTo: process.env.REACT_APP_AUTH0_RETURNTO,
      federated: true
    });
  }

  updateUserMetadata = (userId, userMetadata, callback) => {
    this.auth0Manage.patchUserMetadata(userId, userMetadata, callback);
  };

  getUserMetadata = (userId, callback) => this.auth0Manage.getUser(userId, callback);

  static pushLastRequestedState(to, params) {
    const state = JSON.stringify({ to, params });
    localStorage.setItem("requestedState", state);
  }

  static popLastRequestedState() {
    const state = localStorage.getItem("requestedState");
    localStorage.removeItem("requestedState");
    return JSON.parse(state);
  }

  static setSession(authResult) {
    const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);
  }

  static isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
  }

  static getUser() {
    const userToken = localStorage.getItem("id_token");
    return userToken ? jwtDecode(userToken) : {};
  }

  static getUserRoles() {
    const customClaimsNamespace = process.env.customClaimsNamespace || "https://kruger.com/";
    const accessToken = localStorage.getItem("access_token");

    if (accessToken) {
      const decodedToken = jwtDecode(accessToken);
      const appMetadata = decodedToken[`${customClaimsNamespace}app_metadata`];

      if (appMetadata && appMetadata.rolesByEnvironment) {
        const env = process.env.REACT_APP_AUTH0_RETURNTO;
        if (env.includes("ktrak.kruger.com")) {
          return appMetadata.rolesByEnvironment.prod || [];
        } else if (env.includes("preprod.kruger.live")) {
          return appMetadata.rolesByEnvironment.preprod || [];
        } else if (env.includes("test.kruger.live")) {
          return appMetadata.rolesByEnvironment.test || [];
        } else if (env.includes("dev.kruger.live") || env.includes("localhost:8080")) {
          return appMetadata.rolesByEnvironment.dev || [];
        }
      }

      return appMetadata ? appMetadata.roles : [];
    }

    return [];
  }

  static getAccessToken() {
    return localStorage.getItem("access_token") || {};
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Authentication/Auth.js